import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import FsLightbox from 'fslightbox-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import StringHelper from '../../../../helpers/string-helper';
import defaultHostelThumbnail from '../../../../images/no-picture-room.png';

const RoomGallery = props => {
  const { t } = useTranslation();
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });
  const [currentIndex, setCurrentIndex] = useState(0);
  const { mainPhotoUrl, mainPhotoThumbnailUrl, photos, available } = props;

  const hasMainPhoto =
    StringHelper.isNotEmpty(mainPhotoUrl) &&
    StringHelper.isNotEmpty(mainPhotoThumbnailUrl);

  const hasPhotos = Array.isArray(photos) && photos.length > 0;

  const onOpenLightboxHandler = number => {
    if (!hasPhotos) {
      return;
    }
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number,
    });
  };

  const onPrev = e => {
    e.stopPropagation();
    setCurrentIndex(i => i - 1);
  };

  const onNext = e => {
    e.stopPropagation();
    setCurrentIndex(i => i + 1);
  };

  const photosFiles = photos.map(photo => photo.url);
  const currentPhotoUrl = hasPhotos ? photos[currentIndex].url : null;

  return (!hasPhotos) ?
    <img
      className="img rounded img-fluid room-thumbnail"
      src={defaultHostelThumbnail}
      alt="Room Default Pic"
    />
    :
    (
      <Fragment>
        <div className="room-photo-slider">
          {available === 1 && (
            <span className="room-availability-badge">{t('labels.lastRoomAvailable')}</span>
          )}
          {currentIndex > 0 && (
            <button className="room-photo-nav prev" onClick={onPrev} aria-label="Foto anterior">
              <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: '13px' }} />
            </button>
          )}
          <img
            className={`img rounded img-fluid room-thumbnail${hasMainPhoto ? ' as-link' : ''}`}
            src={currentPhotoUrl || defaultHostelThumbnail}
            onClick={() => onOpenLightboxHandler(currentIndex + 1)}
            alt=""
            style={{ cursor: hasMainPhoto ? 'pointer' : 'default' }}
          />
          {currentIndex < photos.length - 1 && (
            <button className="room-photo-nav next" onClick={onNext} aria-label="Próxima foto">
              <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: '13px' }} />
            </button>
          )}
        </div>
        <FsLightbox
          toggler={lightboxController.toggler}
          slide={lightboxController.slide}
          sources={photosFiles}
          type="image"
        />
      </Fragment>
    );
};

RoomGallery.propTypes = {
  mainPhotoUrl: PropTypes.string,
  mainPhotoThumbnailUrl: PropTypes.string,
  photos: PropTypes.array.isRequired,
  available: PropTypes.number,
};

export default RoomGallery;
